import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'

import { ContentGroups, configureGa4 } from '../logic/ga4'

import useIsClient from './useIsClient'

export const useGa4Config = (contentGroup?: ContentGroups) => {
  const { user } = useAuth0()
  const isClient = useIsClient()

  useEffect(() => {
    if (!isClient) {
      return
    }
    if (contentGroup || user?.sub) {
      configureGa4({ contentGroup, user_id: user?.sub })
    }
  }, [isClient, user])
}
